import React from 'react';
import Sidebar from './Sidebar';
import { Toaster } from 'sonner';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div data-component-id="src\components\AppLayout.tsx:11:4" data-component-path="src\components\AppLayout.tsx" data-component-line="11" data-component-end-line="26" data-component-file="AppLayout.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20h-screen%20overflow-hidden%20bg-background%22%7D" className="flex h-screen overflow-hidden bg-background">
      <Sidebar data-component-id="src\components\AppLayout.tsx:12:6" data-component-path="src\components\AppLayout.tsx" data-component-line="12" data-component-end-line="12" data-component-file="AppLayout.tsx" data-component-name="Sidebar" data-component-content="%7B%22elementName%22%3A%22Sidebar%22%7D" />
      <main data-component-id="src\components\AppLayout.tsx:13:6" data-component-path="src\components\AppLayout.tsx" data-component-line="13" data-component-end-line="13" data-component-file="AppLayout.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22flex-1%20overflow-y-auto%20scrollbar-thin%22%7D" className="flex-1 overflow-y-auto scrollbar-thin">{children}</main>
      <Toaster data-component-id="src\components\AppLayout.tsx:14:6" data-component-path="src\components\AppLayout.tsx" data-component-line="14" data-component-end-line="25" data-component-file="AppLayout.tsx" data-component-name="Toaster" data-component-content="%7B%22elementName%22%3A%22Toaster%22%7D"
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: 'hsl(222 35% 11%)',
            border: '1px solid hsl(222 25% 16%)',
            color: 'hsl(210 40% 96%)',
            fontFamily: 'Geist, system-ui, sans-serif',
          },
        }}
      />
    </div>
  );
}
